import { motion } from "framer-motion";

export function LoadingScreen(){
  return(
    <motion.div 
        className="d-flex justify-content-center align-items-center" 
        style={{ height: '100vh' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <motion.div 
          className="spinner-border" 
          role="status"
          animate={{ rotate: 360 }}
          transition={{ 
            duration: 1, 
            repeat: Infinity, 
            ease: "linear" 
          }}
        >
          <span className="sr-only">Loading...</span>
        </motion.div>
      </motion.div>
  )
}